import { AxiosError } from "axios";
import { ErrorMessage } from "../../constants";
import { AltiusErrors, ApiValidationErrors } from "store/types";

const abortMessage = "canceled";

export interface IApiServiceError {
  message: string;
  status?: number;
  errors: ApiValidationErrors;
  response?: any;
  aborted?: boolean;
}
export class ApiServiceError extends Error implements IApiServiceError {
  readonly errors: ApiValidationErrors;
  readonly response: any;
  readonly status?: number;
  readonly aborted: boolean = false;

  constructor({ response, message }: AxiosError<AltiusErrors>) {
    const errorMessage = response?.data?.message || ErrorMessage.NoMessage;
    super(errorMessage);
    this.name = "ApiServiceError";
    this.errors = response?.data?.errors || {};
    this.message = errorMessage;
    this.response = response?.data;
    this.status = response?.status;

    if (message === abortMessage) {
      this.aborted = true;
    }
  }
}
